import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import { Chip, IconButton, Paper, Tooltip, Typography } from '@mui/material'
import { useState } from 'react'

import { Box, InfoRow } from '@/components/ui'
import type { OrganizationDetail } from '@/definitions/organization'

interface OrgDetailsSectionProps {
  org: OrganizationDetail
}

export const OrgDetailsSection = ({ org }: OrgDetailsSectionProps) => {
  const [copied, setCopied] = useState(false)

  const handleCopyId = async () => {
    try {
      await navigator.clipboard.writeText(org.id)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // clipboard access denied — silently ignore
    }
  }

  return (
    <Paper variant='detailCard'>
      <Box variant='flexColumn' gap='sm'>
        {/* Heading and status to the left, the copyable ID to the right. The row
            wraps rather than overflowing when the card is too narrow to hold both. */}
        <Box variant='flexBetween' gap='sm' flexWrap='wrap'>
          <Box variant='flex' gap='sm'>
            <Typography variant='overline' color='text.secondary'>
              Organization Details
            </Typography>
            <Chip
              variant='status'
              label={org.enabled ? 'Active' : 'Deactivated'}
              color={org.enabled ? 'success' : 'error'}
              size='small'
            />
          </Box>
          <Tooltip title={copied ? 'Copied!' : 'Copy org ID'} placement='top'>
            <Box variant='flex' gap='xs'>
              <Typography variant='caption' color='text.secondary' fontFamily='monospace'>
                {org.id}
              </Typography>
              <IconButton size='small' onClick={handleCopyId} aria-label='Copy org ID'>
                <ContentCopyOutlinedIcon style={{ fontSize: 14 }} />
              </IconButton>
            </Box>
          </Tooltip>
        </Box>

        <Box variant='flexColumn' gap='sm'>
          <InfoRow
            label='Display Name'
            value={org.display_name}
            tooltip='The customer-facing name shown to users of the platform'
          />
          <InfoRow
            label='Legal Name'
            value={org.org_name}
            tooltip='The official registered legal name of the organization (e.g. on tax filings and contracts)'
          />
          <InfoRow label='Domain' value={org.domain_name ?? ''} />
        </Box>
      </Box>
    </Paper>
  )
}
